import { useRef, useCallback } from "react";
import axios from "axios";

export const CANCELED = Symbol("CANCELED");

const useCancelableRequest = (call) => {
  const cancelTokenRef = useRef(null);

  const wrappedCall = useCallback(
    async (...args) => {
      // Cancel the previous request if it exists
      if (cancelTokenRef.current) {
        cancelTokenRef.current.cancel("Operation canceled due to new request.");
        console.log("🔴 Previous request canceled.");
      }

      // Create a new cancel token for the current request
      cancelTokenRef.current = axios.CancelToken.source();

      try {
        return await call(...args, cancelTokenRef.current.token);
      } catch (error) {
        if (axios.isCancel(error)) {
          console.warn("⚠️ Request canceled:", error.message);
          return Promise.reject(CANCELED); // reject with known symbol
        }
        throw error; // let React Query handle real errors
      }
    },
    [call]
  );

  return wrappedCall;
};

export default useCancelableRequest;
